<div class="time-edit-header">
  <ng-content></ng-content>
</div>
